import Image from 'next/image'

interface Props {
  title: string
  list: {
    id: string | number
    title: string
    description: string
    image?: StrapiImageFile
  }[]
}

function CreatorRecognition({ title, list }: Props): JSX.Element {
  return (
    <section className="bg-blue-web-90 text-white font-body">
      <div className="container | py-10 md:py-18">
        <h2
          className="font-heading text-3xl md:text-5xl md:text-center font-medium | max-w-col-10 md:mx-auto mb-8 md:mb-11"
          dangerouslySetInnerHTML={{ __html: title }}
        ></h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-24">
          {list?.map(value => {
            return (
              <div
                key={value.id}
                className="flex flex-col md:flex-row gap-4 lg:gap-8 md:items-center md:justify-center | py-6"
              >
                <div>
                  {value.image?.url ? (
                    <Image
                      src={value.image?.url}
                      width={value.image?.width}
                      height={value.image?.height}
                      alt={value.image?.alternativeText ?? ''}
                    />
                  ) : null}
                </div>

                <div>
                  <h3
                    className="font-heading text-2xl font-semibold | mb-2"
                    dangerouslySetInnerHTML={{ __html: value.title }}
                  ></h3>
                  <span
                    className="text-lg md:text-base"
                    dangerouslySetInnerHTML={{ __html: value.description }}
                  />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default CreatorRecognition
